export default "__VITE_ASSET__DgFOfuQZ__"